import { FunctionComponent, useEffect, useState } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideo from '@/components/UI/EFVideo';

const H: FunctionComponent = () => {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const [smartEnter, setSmartEnter] = useState<boolean>(false);
    const SHOW_TS_BUNDLE_SITE = ['sa', 'za', 'au'].includes(locale);

    let ScrollMagic: any;
    let controller: any;
    useEffect(() => {
        ScrollMagic = (window as any).ScrollMagic;
        controller = new ScrollMagic.Controller();
        return () => {
            (ScrollMagic = null), (controller = null);
        };
    }, []);

    useEffect(() => {
        // 淡入动画
        const origin = '.scroll-trigger-origin-H .sticky-box .first-screen .content';
        const TL = new TimelineMax();
        const box = TweenMax.to(origin, 1, { opacity: 1, ease: undefined });
        TL.add(box, 0);
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onEnter', offset: 0, duration: 200 });
        scene.setTween(TL);
        controller.addScene(scene);
    }, []);

    useEffect(() => {
        const origin = '.scroll-trigger-origin-H';
        const scene = new ScrollMagic.Scene({ triggerElement: origin, triggerHook: 'onLeave', offset: 0 });
        scene.on('enter', () => setSmartEnter(true));
        scene.on('leave', () => setSmartEnter(false));
        controller.addScene(scene);
    }, []);

    return (
        <section className={`H ${css.H} scroll-trigger-origin-H`}>
            <div className="sticky-box">
                {/* 首屏 */}
                <article className={`first-screen ${smartEnter ? 'to' : 'from'}`}>
                    <div className={`content fromOpacity  ${smartEnter ? 'toLocation' : 'fromLocation'}`}>
                        <p className="secH_title">{t('secH_title')}</p>
                        <p className="secH_desc">{t('secH_desc')}</p>
                    </div>
                </article>
                <article className="bg-screen">
                    {SHOW_TS_BUNDLE_SITE && (
                        <EFVideo className="video-box" sources={['/video/landingPage/pc/pc-bc2.mp4', '/video/landingPage/pc/pc-bc2.mp4']} />
                    )}
                    {!SHOW_TS_BUNDLE_SITE && (
                        <EFVideo className="video-box" sources={['/video/landingPage/pc/pc-bc.webm', '/video/landingPage/pc/pc-bc.mp4']} />
                    )}
                </article>
            </div>
        </section>
    );
};

export default H;
